import { postMessage, messages } from 'signer-app/utils/messages';

export function sendEmbeddedSignMessage({
  signatureId,
  parentUrl,
}: {
  signatureId: string;
  parentUrl: string;
}) {
  postMessage(
    {
      type: messages.USER_SIGN_REQUEST,
      payload: { signatureId },
    },
    parentUrl,
  );
}

export function sendEmbeddedFinishMessage(parentUrl: string) {
  postMessage({ type: messages.USER_FINISH_REQUEST }, parentUrl);
}

/**
 * The embedded redirect gets some additional parameters attached to the URL
 */
export function createEmbeddedRedirectURL({
  redirectUrl,
  signatureId,
}: {
  redirectUrl: string;
  signatureId: string;
}) {
  const urlWithEventData = new URL(redirectUrl);
  urlWithEventData.searchParams.append('signature_id', signatureId);

  // NOTE: This event name is from the V1 embedded library
  urlWithEventData.searchParams.append('event', 'signature_request_signed');

  return urlWithEventData.toString().replace(/^http:/, '');
}
